import type { Rule } from 'antd/es/form';

export const APP_USERNAME_INVALID_MESSAGE =
  'Допустимы только латинские буквы, цифры, спецсимволы (- _ .)';

export const APP_PASSWORD_HINT_TEXT =
  'Не менее 8 символов, заглавная и строчная латинские буквы, цифра, спецсимволы ! @ # $ % ^ & * ( ) _ - +';

export const APP_PASSWORD_INVALID_MESSAGE =
  'Пароль не соответствует требованиям';

const USERNAME_PATTERN = /^[A-Za-z0-9_.-]+$/;
const PASSWORD_PATTERN =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+-])[A-Za-z\d!@#$%^&*()_+-]{8,}$/;

const createRule = (
  isValid: (value: string) => boolean,
  message: string,
): Rule => ({
  validator: (_, value?: string) => {
    if (!value) {
      return Promise.resolve();
    }

    return isValid(value)
      ? Promise.resolve()
      : Promise.reject(new Error(message));
  },
});

export const isValidAppUsername = (value: string): boolean =>
  USERNAME_PATTERN.test(value);

export const isValidAppPassword = (value: string): boolean =>
  PASSWORD_PATTERN.test(value);

export const getAppUsernameRules = (): Rule[] => [
  createRule(isValidAppUsername, APP_USERNAME_INVALID_MESSAGE),
];

export const getAppPasswordRules = (): Rule[] => [
  createRule(isValidAppPassword, APP_PASSWORD_INVALID_MESSAGE),
];
